// extracted by mini-css-extract-plugin
module.exports = {"form":"DemoHtml_form__Et0Lq","document":"DemoHtml_document__2XZ-6","signButton":"DemoHtml_signButton__1pGQ2"};